import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

/**
 * Composant Google Analytics
 * Track les pages vues et les événements utilisateur
 *
 * IMPORTANT: Remplacer 'G-XXXXXXXXXX' par votre vrai ID Google Analytics
 */
const GoogleAnalytics = ({ measurementId = 'G-XXXXXXXXXX' }) => {
  const location = useLocation()

  // Tracker les changements de page
  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', measurementId, {
        page_path: location.pathname + location.search,
      })
    }
  }, [location, measurementId])

  // Fonction utilitaire pour tracker des événements personnalisés
  // Peut être utilisée partout dans l'app via window.trackEvent()
  useEffect(() => {
    window.trackEvent = (action, category, label, value) => {
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', action, {
          event_category: category,
          event_label: label,
          value: value,
        })
      }
    }
  }, [])

  return (
    <Helmet>
      {/* Google Analytics Script */}
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
      />
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}', {
            page_path: window.location.pathname,
            anonymize_ip: true
          });
        `}
      </script>
    </Helmet>
  )
}

// Hook personnalisé pour faciliter le tracking d'événements
export const useAnalytics = () => {
  const trackPageView = (page) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: page,
      })
    }
  }

  const trackEvent = (action, category = 'General', label = '', value = 0) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      })
    }
  }

  const trackButtonClick = (buttonName, location) => {
    trackEvent('button_click', 'Engagement', `${buttonName} - ${location}`)
  }

  const trackFormSubmit = (formName) => {
    trackEvent('form_submit', 'Lead Generation', formName)
  }

  const trackCalculatorUse = (investmentType, amount) => {
    trackEvent('calculator_use', 'Tools', `${investmentType} - ${amount}€`)
  }

  const trackLanguageChange = (newLanguage) => {
    trackEvent('language_change', 'Preferences', newLanguage)
  }

  return {
    trackPageView,
    trackEvent,
    trackButtonClick,
    trackFormSubmit,
    trackCalculatorUse,
    trackLanguageChange
  }
}

export default GoogleAnalytics
